module.exports = __webpack_public_path__ + "static/media/No Bake Cheesecake.3bbd9835.jpg";